// Submittable product types are the sub-types of a submission type
// i.e. reels vs carousels on Instagram
exports.INSTAGRAM_SUBMITTABLE_PRODUCT_TYPES = {
  /* These are mediaType values in the external post docs */
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  CAROUSEL_ALBUM: 'CAROUSEL_ALBUM',

  /* These are mediaProductType values in the external post docs */
  REELS: 'REELS',
  FEED: 'FEED',
}
